import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
    SET_USER_ACCOUNT,
    SYSTEM_DELETE_USER_ACCOUNT,
    SYSTEM_EDIT_USER_ACCOUNT,
    SYSTEM_GET_USER_ACCOUNT,
    SYSTEM_GET_USER_GROUP,
    UPDATE_USER_ACCOUNT_STATUS,
    SYSTEM_GET_USER_ACCOUNT_DETAIL,
    SYSTEM_UPDATE_USER_ACCOUNT
} from 'store/key';
import { produce } from 'utility/general';

import api from 'api/call';
import { safeSaga } from 'store';
import { userRoles } from 'utility/lookup';

const initialState = {
    userAccountList: [],
    roleList: [],
    clusterList: [],
    irbList: [],
    secretaryList: [],
    pageSize: 10,
    page: 1,
    userAccountDetail: null
};

function* getUserAccounts(action) {
    try {
        const { page = 1, pageSize = 10, isDesc = true, sort = 'createDtm', param = '' } = action.payload;

        yield put({
            type: SET_USER_ACCOUNT,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.userAccount.getUserAccounts, {
            page,
            pageSize,
            isDesc,
            sort,
            param
        });

        const { result } = res.data;

        const { data, total } = result;
        let finalData = data;
        finalData.forEach((item) => {
            if (!item.userGroup) item.userGroup = '';
            else {
                const groups = item.userGroup.split(',');
                let groupsShow = [];
                for (let i = 0; i < groups.length; i++) {
                    const g = groups[i];
                    if (!g) continue;
                    const displayName = userRoles
                        .find((item) => {
                            return item.key === g;
                        })?.display;
                    groupsShow.push(displayName || g);
                }

                item.userGroup = groupsShow.join(', ');
            }
        });
        yield put({
            type: SET_USER_ACCOUNT,
            payload: {
                total,
                userAccountList: finalData,
                page,
                pageSize,
                sort,
                isDesc
            },
        });
    } catch (error) {
        console.log('120600 reducer.js error', error);
    }

    yield put({
        type: SET_USER_ACCOUNT,
        payload: {
            isLoading: false,
        },
    });
}

function* getUserGroups(action) {
    try {
        const res = yield call(api.userAccount.getUserGroups, null);
        const { result } = res.data;

        let roleList = result.masterRoleResponList.map((item) => {
            item.checked = false;
            return item;
        });
        let clusterList = result.masterClusterResponList.filter(item => item.clusterCode !== 'OTHERS').map((item) => {
            item.checked = false;
            return item;
        });
        let irbList = result.irbList.map((item) => {
            item.checked = false;
            return item;
        });
        let secretaryList = result.secretaryList.map((item) => {
            item.checked = false;
            return item;
        });

        yield put({
            type: SET_USER_ACCOUNT,
            payload: {
                roleList: roleList,
                clusterList: clusterList,
                irbList,
                secretaryList
            },
        });
    } catch (error) {
        console.log('120600 reducer.js error', error);
    }

    yield put({
        type: SET_USER_ACCOUNT,
        payload: {
            isLoading: false,
        },
    });
}


function* editUserAccount(action) {
    const row = action.payload;
    const { system: state } = yield select();
    let list = state.userAccountList;
    const index = list.findIndex((i) => i.id === row.id);
    state.userAccountList[index] = { ...row };
    yield put({
        type: SET_USER_ACCOUNT,
        payload: state,
    });
}

function* deleteUserAccount(action) {
    const row = action.payload;
    const { system: state } = yield select();
    let list = state.userAccountList;
    const index = list.findIndex((i) => i.id === row.id);
    state.userAccountList.splice(index, 1);
    yield put({
        type: SET_USER_ACCOUNT,
        payload: state,
    });
}

function* updateUserAccountStatus(action) {
    try {
        const { row, callback = () => null } = action.payload;
        const res = yield call(api.userAccount.updateUserAccountStatus, { status: row.status, userId: row.id });
        if (res.status) {
            callback();
        }
    } catch {

    }
};
function* getUserAccountDetail(action) {
    try {
        yield put({
            type: SET_USER_ACCOUNT,
            payload: {
                isLoading: true,
            },
        });

        const { userid } = action.payload;

        const res = yield call(api.userAccount.getUserAccountDetail, userid);
        const { result } = res.data;

        yield put({
            type: SET_USER_ACCOUNT,
            payload: {
                userAccountDetail: result
            },
        });
    } catch (error) {
        console.log('user account reducer.js error', error);
    }

    yield put({
        type: SET_USER_ACCOUNT,
        payload: {
            isLoading: false,
        },
    });
}

function* updateUserAccount(action) {
    try {
        const { row, callback } = action.payload;
        yield call(api.userAccount.updateUserAccount, row);
        callback?.();
    } catch (error) {
        console.log('user account reducer.js error', error);
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_ACCOUNT:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchUserAccount() {
    yield takeEvery(SYSTEM_EDIT_USER_ACCOUNT, safeSaga(editUserAccount));
    yield takeEvery(SYSTEM_DELETE_USER_ACCOUNT, safeSaga(deleteUserAccount));
    yield takeEvery(SYSTEM_GET_USER_ACCOUNT, safeSaga(getUserAccounts));
    yield takeEvery(SYSTEM_GET_USER_GROUP, safeSaga(getUserGroups));
    yield takeEvery(UPDATE_USER_ACCOUNT_STATUS, safeSaga(updateUserAccountStatus));
    yield takeEvery(SYSTEM_GET_USER_ACCOUNT_DETAIL, safeSaga(getUserAccountDetail));
    yield takeEvery(SYSTEM_UPDATE_USER_ACCOUNT, safeSaga(updateUserAccount));
}

export default reducer;
